/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byline_UpdatedInputs */

const en_byline_updated = /** @type {(inputs: Byline_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated`)
};

const ko_byline_updated = /** @type {(inputs: Byline_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최종 수정`)
};

const ja_byline_updated = /** @type {(inputs: Byline_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新`)
};

/**
* | output |
* | --- |
* | "Last updated" |
*
* @param {Byline_UpdatedInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const byline_updated = /** @type {((inputs?: Byline_UpdatedInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byline_UpdatedInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_byline_updated(inputs)
	if (locale === "ko") return ko_byline_updated(inputs)
	return ja_byline_updated(inputs)
});